import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
import { CheckboxLabel, CheckboxInput } from './wrapper/CheckboxWrapper';

const RadioButtonInput = styled(CheckboxInput)`
  border-radius: 50%;

  /* Style the indicator (dot/circle) */
  &:after {
    border-radius: 50%;
  }
`

const RadioButton = (props) => (
  <CheckboxLabel>
    <Field type="radio" name={props.name} value={props.value} />
    <RadioButtonInput />
    {props.children}
  </CheckboxLabel>
);

export default RadioButton;